import { ceil, floor, subtract, sum, min, max } from 'mathjs';

// min/max: track ends; beyond inner_min/inner_max the bound is unlimited.
export function extend_bounds({ raw_min, raw_max, step, open_start, open_end }) {
  const inner_min = ceil(raw_min);
  const inner_max = floor(raw_max);
  return {
    min: open_start ? ceil(subtract(raw_min, step)) : inner_min,
    inner_min,
    inner_max,
    max: open_end ? floor(sum(raw_max, step)) : inner_max,
  };
}

// value === null: unlimited lower bound.
export function normalize_min(value, current_max, bounds) {
  let position = max(bounds.min, min(value, current_max, bounds.inner_max));
  if (position < bounds.inner_min) {
    const near_inner =
      subtract(bounds.inner_min, position) <
      subtract(bounds.inner_min, bounds.min) / 2;
    position = near_inner ? bounds.inner_min : bounds.min;
  }
  const unbounded = bounds.min < bounds.inner_min && position === bounds.min;
  return { position, value: unbounded ? null : position };
}

// value === null: unlimited upper bound.
export function normalize_max(value, current_min, bounds) {
  let position = min(bounds.max, max(value, current_min, bounds.inner_min));
  if (position > bounds.inner_max) {
    const near_inner =
      subtract(position, bounds.inner_max) <
      subtract(bounds.max, bounds.inner_max) / 2;
    position = near_inner ? bounds.inner_max : bounds.max;
  }
  const unbounded = bounds.max > bounds.inner_max && position === bounds.max;
  return { position, value: unbounded ? null : position };
}

// Lowest max that keeps the whole bucket containing current_min (one bar at least).
export function lowest_max(scale, current_min) {
  const bucket = scale.find((item) => floor(item.max) > current_min);
  return bucket ? floor(bucket.max) : current_min;
}

// Highest min that keeps the whole bucket containing current_max (one bar at least).
export function highest_min(scale, current_max) {
  const bucket = [...scale].reverse().find((item) => ceil(item.min) < current_max);
  return bucket ? ceil(bucket.min) : current_max;
}
